<template>
    <div class="sales-card-page" v-if="cardArr != null" :class="{'scrollEvent' : !isVisisbleOnScrollEvent}">
        <SalesCardNav :salesCardArr="cardArr"></SalesCardNav>
        <div class="container">
            <SalesPromo :salesCardArr="cardArr"></SalesPromo>
            <SalesAbout :salesCardArr="cardArr"></SalesAbout>
            <SalesPrems :salesCardArr="cardArr" id="sales-card-prems-section"></SalesPrems>
            <SalesLocation :salesCardArr="cardArr" id="sales-card-location-section" v-if="cardArr.project_page_in.location_menu.init"></SalesLocation>
            <SalesGallery :salesCardArr="cardArr" v-if="cardArr.project_page_in.gallery_menu.init"></SalesGallery>
            <SalesImportant :salesCardArr="cardArr" v-if="cardArr.project_page_in.important_init"></SalesImportant>
            <SalesExclusive :salesCardArr="cardArr" id="sales-card-exclusive-section" v-if="cardArr.project_page_in.exclusive_menu.init"></SalesExclusive>
            <SalesNews :salesCardArr="cardArr" id="sales-card-news-section" v-if="cardArr.project_page_in.news_menu.init"></SalesNews>
        </div>
        <SalesVideoModal v-if="isOpenVideoModal"></SalesVideoModal>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import SalesCardNav from '@/components/sales-card/sales-card-nav.vue';
    import SalesPromo from '@/components/sales-card/sales-promo.vue';
    import SalesAbout from '@/components/sales-card/sales-about.vue';
    import SalesPrems from '@/components/sales-card/sales-prems.vue';
    import SalesLocation from '@/components/sales-card/sales-location.vue';
    import SalesGallery from '@/components/sales-card/sales-gallery.vue';
    import SalesImportant from '@/components/sales-card/sales-important.vue';
    import SalesExclusive from '@/components/sales-card/sales-exclusive.vue';
    import SalesNews from '@/components/sales-card/sales-news.vue';
    import SalesVideoModal from '@/components/sales-card/sales-card-video-modal.vue';
    import formPage from '@/components/forms/form-page.vue'
    import store from '@/store.js'
    export default {
        name: 'sales-card-page',
        components: {
            svgIcon,
            SalesCardNav,
            SalesPromo,
            SalesAbout,
            SalesPrems,
            SalesLocation,
            SalesGallery,
            SalesImportant,
            SalesExclusive,
            SalesNews,
            SalesVideoModal,
            formPage,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                cardArr: null,
                title: '',
                contentDescription: '',
                keyWordsContent: '',
            }
        },
        metaInfo() {
            // console.log(this.cardID, 'asdasdasdas')
            if (this.cardID == 'seyfullin-park') {
                this.title = 'Жилой комплекс SEYFULLIN PARK от DIAL GROUP';
                this.contentDescription = 'Жилой комплекс стандарт-класса в 15 минутах от центра Алматы';
                this.keyWordsContent = 'ЖК алматы, сейфулин парк, SEYFULLIN PARK, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'raiymbek-park') {
                this.title = 'Жилой комплекс RAIYMBEK PARK от DIAL GROUP';
                this.contentDescription = 'RAIYMBEK PARK – ваш идеальный выбор для современной жизни. Уютные апартаменты, зеленые зоны и безопасная обстановка создадут идеальные условия для вашей семьи. Добро пожаловать в наш уютный мир!';
                this.keyWordsContent = 'ЖК алматы, RAIYMBEK PARK, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'dial-residence') {
                this.title = 'Жилой комплекс DIAL RESIDENCE от DIAL GROUP';
                this.contentDescription = 'Жилой комплекс бизнес класса в центре мегаполиса';
                this.keyWordsContent = 'ЖК алматы, DIAL RESIDENCE, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'assem-plaza') {
                this.title = 'Жилой комплекс ASSEM PLAZA от DIAL GROUP';
                this.contentDescription = 'Престижный жилой комплекс, воплощение роскоши и современного комфорта в самом сердце города.';
                this.keyWordsContent = 'ЖК алматы, ASSEM PLAZA, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'double-star') {
                this.title = 'Жилой комплекс DOUBLE STAR от DIAL GROUP';
                this.contentDescription = 'Ваш идеальный дом в сердце Алматы';
                this.keyWordsContent = 'ЖК алматы, DOUBLE STAR, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'nur-ay-residence') {
                this.title = 'Жилой комплекс NUR-AY RESIDENCE от DIAL GROUP';
                this.contentDescription = 'Жилой комплекс бизнес-класса в центре города';
                this.keyWordsContent = 'ЖК алматы, NUR-AY RESIDENCE, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'elif-towers') {
                this.title = 'Жилой комплекс ELIF TOWERS от DIAL GROUP';
                this.contentDescription = 'Современный проект, который станет символом комфорта и роскоши.';
                this.keyWordsContent = 'ЖК алматы, ELIF TOWERS, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            } else if (this.cardID == 'ideal-residence') {
                this.title = 'Жилой комплекс IDEAL RESIDENCE от DIAL GROUP';
                this.contentDescription = 'Жилой комплекс в стиле таунхауса в верхней части города';
                this.keyWordsContent = 'ЖК алматы, IDEAL RESIDENCE, жилой комплекс, Dial Stroy, Dial Group, DIAL, диал'
            }
            return {
                title: this.title,
                meta: [
                    { name: 'description', content:  this.contentDescription},
                    { name: 'keywords', content:  this.keyWordsContent},
                ]
            };
        },
        methods: {
        },
        computed: mapGetters({
            pageSetup: 'loadNewsPage',
            isVisisbleOnScrollEvent: 'loadIsVisibleScrollEvent',
            isOpenVideoModal: 'loadIsOpenSalesCardVideoModal',
        }),
        beforeRouteEnter (to, from, next) {
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/sales-cards/?slug=' + to.params.id).then(async (response) => {
                // console.log(response, 'SALES CARD', to.params.id);
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArr = response.data[0].acf;
                    });
                } else {
                    next('/404');
                }
            });
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
        },
        created () {
            document.body.dataset.page = 'sales-card';

        },
        mounted () {
            // this.getData();
            // this.$store.watch(
            //     (state) => state.actionsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.getData();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-page.scss';
    @import '@/styles/components/sales-card/respond/sales-card-page-respond.scss';
</style>